<template>
  <div>
    <v-btn
      :loading="loading"
      class="mx-2"
      fab
      dark
      small
      color="primary"
      @click="loadMenages()"
    >
      <v-icon dark>
        mdi-cached
      </v-icon>
    </v-btn>
  </div>
</template>

<script>
export default {
  data() {
    return {
      menages: [],
      loading: false,
    };
  },
  props: {
    projet: {
      required: true,
    },
  },

  methods: {
    loadMenages() {
      // console.log("loadMenages", this.projet);
      let self = this;
      self.loading = true;
      self.$firebase
        .firestore()
        .collection("newMenages")
        .where("projectList", "array-contains", self.projet.id)
        .get()
        .then((snap) => {
          snap.forEach((doc) => {
            var menage = doc.data();
            menage.id = doc.id;
            self.menages.push(menage);
          });
          self.loading = false;
          self.updateProjet(self.menages.length);
          self.$emit("updateProjet");
        });
    },

    updateProjet(nombre) {
      let self = this;
      var ref = self.$firebase
        .firestore()
        .collection("projets")
        .doc(self.projet.id);

      ref.set(
        {
          nbreMenage: nombre,
          dateStatMenage: self.$moment().format("YYYY-MM-DD HH:mm:ss"),
        },
        { merge: true }
      );
    },
  },
};
</script>

<style scoped></style>
